<template>
    <div class="wrapper notificationContainerWrapper">
        <div class="top notificationContainer">
            <img src="/assets/img/info.svg">
            <span>{{ text }}</span>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            text: {
                type: String
            },
        },

        components: { },

        mounted() {

        },

        methods: {

        },
        watch: {

        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 1179px) {
        .notificationContainerWrapper {
            padding-left: 15px;
            padding-right: 15px;
        }
    }
</style>